import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { importAnnouncementFromCsv } from '@/apis/announcements'
import routes from '@/constants/routes'
import useNotification from '@/hooks/useNotification'
import { ImportAnnouncementsFromCsvRequest, ImportAnnouncementsFromCsvResponse } from '@/types/apis/announcements'

export const useImportAnnouncement = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<ImportAnnouncementsFromCsvResponse>()

  const imp = useCallback(
    async (request: ImportAnnouncementsFromCsvRequest) => {
      try {
        setLoading(true)
        const res = await importAnnouncementFromCsv(request)
        setResponse(res)
        openNotification({ description: t('pages.announcements.importFromCsv.importSuccessfully') })
        navigate(routes.announcements.path)
      } catch (error) {
        openNotification({ description: t('pages.announcements.importFromCsv.importFailed'), type: 'error' })
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  return {
    loading,
    importAnnouncement: imp,
    response,
  }
}
